/* eslint-disable */
// Votra Business 2.0 — verificeret entitet, ydelsesstruktur og faste tekstbyggesten.
// Regel: intet tal eller claim i denne fil uden kilde. Kommende funktioner markeres "soon".

import { SITE_URL } from "../../components/Seo";

export const BUSINESS = {
  name: "Votra Business",
  legalName: "Votra Business ApS",
  cvr: "46818296",
  vatId: "DK46818296",
  email: "kundeservice@votra.dk",
  phone: "+45 55 29 28 28",
  phoneHref: "+4555292828",
  oneLiner: "Vi driver forretningen bag din vognmandsforretning.",
  category: "Ekstern drifts- og økonomiafdeling for vognmænd",
  registered: {
    label: "Registreret adresse",
    co: "c/o BlueGate Holding ApS",
    street: "Sct. Hansgade 9",
    zip: "4100",
    city: "Ringsted",
  },
  office: {
    label: "Kontor",
    street: "Transformervej 14",
    zip: "2860",
    city: "Søborg",
  },
  groupLine:
    "Votra Business ApS er en del af Votra-koncernen sammen med Votra Danmark ApS, der har uddannet vognmænd og chauffører siden 2015.",
  elevator:
    "Votra Business er en ekstern drifts- og økonomiafdeling for vognmænd. I stedet for at have en bogholder, en flådeansvarlig, en controller og en administrativ medarbejder, eller selv at sidde med det om aftenen, lægger du opgaverne hos os. Vi bogfører, fakturerer, følger debitorerne, kører lønnen, administrerer bilernes aftaler og omkostninger og holder øje med chaufførernes dokumenter og udløbsdatoer. Du ser det hele i din egen portal, og du har en fast rådgiver.",
};

export const ADDRESS_LINE = `${BUSINESS.office.street}, ${BUSINESS.office.zip} ${BUSINESS.office.city}`;

/* -------------------- Navigation -------------------- */
export const NAV = [
  { label: "Vognmænd", to: "/business/vognmaend" },
  { label: "Beregnere", to: "/business/beregnere" },
  {
    label: "Ydelser",
    children: [
      { label: "Drift & backoffice", to: "/business/drift" },
      { label: "Financial controlling", to: "/business/financial-controlling" },
      { label: "Fleet management", to: "/business/fleet-management" },
      { label: "Compliance & dokumenter", to: "/business/compliance" },
      { label: "Regnskab & bogføring", to: "/business/regnskab" },
      { label: "Løn", to: "/business/loen" },
      { label: "Rammeaftaler", to: "/business/rammeaftaler" },
      { label: "Virksomhedsopstart", to: "/business/virksomhedsopstart" },
      { label: "Vækst & næste bil", to: "/business/vaekst" },
      { label: "Rekruttering", to: "/business/rekruttering" },
      { label: "Andre virksomheder", to: "/business/andre-virksomheder" },
    ],
  },
  { label: "Portal", to: "/business/portal" },
  { label: "Viden", to: "/business/viden" },
  { label: "Om os", to: "/business/om-os" },
  { label: "Kontakt", to: "/business/kontakt" },
];

/* -------------------- Syv områder i kunderejsens rækkefølge -------------------- */
// mode: "self" = vi udfører · "network" = aftalen ligger hos leverandøren, arbejdet ligger hos os
// · "group" = løses i Votra-koncernen · soon: funktion under udvikling
export const SERVICE_AREAS = [
  {
    n: "01",
    id: "start",
    title: "Start",
    question: "Jeg vil være vognmand",
    mode: "self",
    to: "/business/virksomhedsopstart",
    summary:
      "Selskab, struktur, åbningsbudget og tilladelsesproces, og en administration der er sat rigtigt op fra første dag.",
    items: [
      "Stiftelse af ApS og registrering af CVR",
      "Åbningsbudget og likviditetsplan før første bil",
      "Ansøgning om gods- eller varebilstilladelse",
      "Opsætning af regnskab, fakturering og dokumentflow",
    ],
  },
  {
    n: "02",
    id: "operate",
    title: "Drift",
    question: "Jeg har biler og chauffører",
    mode: "self",
    to: "/business/drift",
    summary:
      "Vi overtager backoffice. Bogføring, moms, løn, fakturering, debitorer og leverandørkontakt kører hos os, hver måned.",
    items: [
      "Løbende bogføring og momsopgørelse",
      "Fakturering, rykkere og debitoropfølgning",
      "Løn og chaufførafregning",
      "Leverandørfakturaer, kontrol og betalingsklargøring",
    ],
  },
  {
    n: "03",
    id: "control",
    title: "Controlling",
    question: "Jeg vil forstå min økonomi",
    mode: "self",
    to: "/business/financial-controlling",
    summary:
      "Fra bilag til beslutning. Vi sætter tallene op, så du kan se hvad der tjener penge, og hvad der ikke gør.",
    items: [
      "Kvartalsgennemgang med gennemgang af resultat og likviditet",
      "Omkostningsstruktur: løn, diesel, leasing, service, dæk",
      "Resultat pr. bil, chauffør og kontrakt",
      "Månedlig ledelsesrapport",
    ],
    soonItems: ["Automatiseret KPI-dashboard", "Automatisk månedsrapport i portalen"],
  },
  {
    n: "04",
    id: "fleet",
    title: "Fleet",
    question: "Jeg vil styre bilerne bedre",
    mode: "self",
    to: "/business/fleet-management",
    summary:
      "Administrativ flådestyring. Aftaler, omkostninger, frister og dokumenter pr. bil, samlet ét sted.",
    items: [
      "Register over biler med leasing, forsikring, service og dæk",
      "Aftaler med leverandør, beløb, start- og slutdato og dokument",
      "Kontrol af leverandørfakturaer mod aftale",
      "Frister: syn, tachograf, forsikring, leasingudløb",
    ],
    soonItems: ["Cost pr. km og utilization pr. bil", "Automatiske notifikationer på tværs af dokumenttyper"],
  },
  {
    n: "05",
    id: "comply",
    title: "Compliance",
    question: "Må jeg køre i morgen?",
    mode: "self",
    to: "/business/compliance",
    summary:
      "Administrativ dokument- og fristovervågning. Vi holder styr på papirerne, ikke på juraen.",
    items: [
      "Chaufførdokumenter: kørekort, EU-bevis, førerkort, ADR",
      "Udløbsdatoer samlet pr. medarbejder",
      "Ansættelseskontrakter og overenskomstvilkår på plads",
      "Certificeret sikkerhedsrådgiver (ADR) i huset",
      "Dokumentarkiv du kan trække fra ved kontrol",
    ],
  },
  {
    n: "06",
    id: "save",
    title: "Rammeaftaler",
    question: "Jeg vil sænke omkostningerne",
    mode: "network",
    to: "/business/rammeaftaler",
    summary:
      "Vi gennemgår dine faste omkostninger og viser hvor der er noget at hente. Aftalen indgår du selv med leverandøren.",
    items: [
      "Gennemgang af faste omkostninger pr. bil",
      "Adgang til relevante aftaler gennem vores partnernetværk",
      "Vi henter tilbud, sammenligner og lægger det frem",
      "Vi håndterer papirarbejdet og den løbende administration",
    ],
  },
  {
    n: "07",
    id: "grow",
    title: "Vækst",
    question: "Jeg vil have flere biler og større kontrakter",
    mode: "self",
    to: "/business/vaekst",
    summary:
      "Hvornår kan næste bil betale sig? Vi regner på det, før du skriver under, og bygger administrationen så den kan følge med.",
    items: [
      "Budget og break-even for næste bil",
      "Beslutningsgrundlag før en ny kontrakt",
      "Rekruttering af chauffører",
      "Uddannelse gennem Votra-koncernen",
    ],
  },
];

export const MODE_LABEL = {
  self: "Vi udfører",
  network: "Gennem partnernetværk",
  group: "I Votra-koncernen",
};

/* -------------------- Pakker (ingen priser) -------------------- */
export const PACKAGES = [
  {
    name: "Business",
    tagline: "Bogholderiet ud af huset",
    unit: "Grundpris pr. måned efter bilagsmængde",
    items: [
      "Løbende bogføring",
      "Momsopgørelse og indberetning",
      "Fakturering og basisadministration",
      "Fast rådgiver og adgang til portalen",
    ],
  },
  {
    name: "Business+",
    tagline: "Økonomifunktionen ud af huset",
    unit: "Grundpris + pris pr. medarbejder",
    featured: true,
    items: [
      "Alt i Business",
      "Løn og chaufførafregning",
      "Debitor- og kreditorstyring",
      "Financial controlling og kvartalsgennemgang",
    ],
  },
  {
    name: "Business Partner",
    tagline: "Hele driftskontoret",
    unit: "Grundpris + pris pr. bil + pris pr. medarbejder",
    items: [
      "Alt i Business+",
      "Administrativ fleet management",
      "Compliance- og dokumentovervågning",
      "Adgang til rammeaftaler gennem partnernetværket",
      "Månedlig ledelsesrapport",
    ],
  },
];

/* -------------------- Onboarding i 8 trin -------------------- */
export const ONBOARDING = [
  { n: "01", title: "Driftsgennemgang", desc: "Vi gennemgår din forretning: biler, chauffører, kontrakter, systemer og hvad du selv sidder med i dag." },
  { n: "02", title: "Data og dokumenter", desc: "Vi henter bilag, kontrakter, forsikringer, leasingaftaler og chaufførpapirer ind og får overblik over hullerne." },
  { n: "03", title: "Regnskabssystem", desc: "Vi overtager eller opretter dit regnskab, sætter kontoplanen op til transport og rydder op i åbne poster." },
  { n: "04", title: "Køretøjer", desc: "Hver bil oprettes med leasing, forsikring, service, dæk, aftaler, beløb og udløbsdatoer." },
  { n: "05", title: "Chauffører", desc: "Kontrakter, overenskomstvilkår, kørekort, EU-bevis, førerkort og ADR samles med udløbsdatoer." },
  { n: "06", title: "Aftaler og leverandører", desc: "Vi gennemgår dine faste omkostninger og tager kontakten til leverandørerne fremadrettet." },
  { n: "07", title: "Baseline", desc: "Vi fastlægger dine nøgletal, så du har et udgangspunkt at måle de næste måneder imod." },
  { n: "08", title: "Månedlig drift", desc: "Herefter kører det: bogføring, løn, fakturering, opfølgning, frister og rapportering, hver måned." },
];

/* -------------------- Portalen: findes i dag vs. under udvikling -------------------- */
export const PORTAL_NOW = [
  { title: "Mine kontrakter", desc: "Dine aftaler med Votra Business med digital underskrift i to led og synlig status." },
  { title: "Bogføring", desc: "Status på den løbende bogføring, så du kan se hvor langt vi er." },
  { title: "Moms", desc: "Momsperioder og opgørelser samlet." },
  { title: "Bank & likviditet", desc: "Overblik over bank og likviditet." },
  { title: "Kvartalskontrol", desc: "Kvartalsvis gennemgang dokumenteret i portalen." },
  { title: "Medarbejdere", desc: "Ansættelseskontrakter med kørekort, EU-bevis, førerkort og ADR, inkl. udløbsdatoer." },
  { title: "Transport-aftaler", desc: "Forsikring, leasing, brændstof m.fl. med leverandør, beløb, periode og dokument." },
  { title: "Fakturaer og dokumenter", desc: "Arkiv over fakturaer og vedhæftninger." },
  { title: "Min rådgiver", desc: "Din faste kontaktperson, ikke en supportkø." },
  { title: "Webshop og opsætning", desc: "Bestilling af ydelser og kundeindstillinger." },
];

export const PORTAL_SOON = [
  { title: "Resultat pr. bil, chauffør og kontrakt", desc: "Vi leverer det i dag som del af controlling. Den automatiske visning i portalen er under udvikling." },
  { title: "KPI-dashboard", desc: "Dækningsbidrag, cost pr. km og utilization samlet i ét billede." },
  { title: "Automatisk ledelsesrapport", desc: "Månedsrapport genereret direkte fra driftsdata." },
  { title: "Automatiske fristnotifikationer", desc: "Varsling på tværs af alle dokumenttyper og aftaler." },
];

/* -------------------- Afgrænsning, det gør vi ikke -------------------- */
export const BOUNDARIES = [
  { title: "Vi er ikke revisorer", desc: "Vi laver bogføring, moms, løn, fakturering, controlling og årsrapporten selv. Skal regnskabet revideres eller forsynes med en revisorerklæring, fordi banken, et udbud eller et leasingselskab kræver det, løses den del af en revisor." },
  { title: "Vi sælger ikke forsikring", desc: "Forsikring er det eneste, vi lægger uden for huset. Rådgivning og formidling ligger hos partneren, vi håndterer administrationen og holder øje med aftalen og fristerne." },
  { title: "Vi er ikke advokater", desc: "Vi laver administrativ dokumentstyring og overvåger frister. Juridisk rådgivning og tvister hører hos en advokat." },
  { title: "Vi er ikke telematikleverandør", desc: "Vi sælger ikke GPS eller kørebøger. Vi kan arbejde med de data, dit system giver, vi laver økonomien omkring dem." },
  { title: "Vi leaser og finansierer ikke", desc: "Vi hjælper dig gennem processen med leasing- og finansieringspartnere, men aftalen og kreditvurderingen ligger hos leverandøren." },
  { title: "Vi lover dig ikke omsætning", desc: "Vi sælger ikke kørselsopgaver og garanterer ikke kontrakter. Vi gør dig i stand til at regne på dem, du får tilbudt." },
];

/* -------------------- Partnere med rolle -------------------- */
export const PARTNERS = [
  {
    name: "fleetpartner.dk",
    src: "/partners/fleetpartner.png",
    role: "Indkøbsfællesskab. Gennem samarbejdet kan du få adgang til Fleetpartners rammeaftaler, i dag primært forsikring.",
  },
  {
    name: "Söderberg & Partners",
    src: "/partners/soderberg-partners.jpg",
    role: "Forsikring og pension. Rådgivning og formidling ligger hos partneren; vi håndterer administrationen omkring aftalen.",
  },
  {
    name: "Circle K",
    src: "/partners/circle-k.png",
    role: "Brændstof og tankkort. Aftalen er mellem dig og leverandøren, vi står for bestilling, kontrol og afstemning.",
  },
  {
    name: "e-conomic",
    src: "/partners/economic.png",
    role: "Regnskabssystem. Vi arbejder i e-conomic for de kunder, der bruger det.",
  },
  {
    name: "Danske Bank",
    src: "/partners/danske-bank.png",
    role: "Bank. Konti, betalinger og finansiering aftales mellem dig og banken; vi afstemmer og klargør betalinger.",
  },
  {
    name: "GS Revision",
    src: "/partners/gs-revision.png",
    role: "Autoriseret revisor tilknyttet Votra. Revision, revisorerklæringer og årsregnskaber med påtegning løses af GS Revision. Votra Business er ikke revisor.",
  },
  {
    name: "DA Revision",
    src: "/partners/da-revision.webp",
    role: "Revisionshus i vores netværk. Revisionsopgaver og erklæringer løses af revisor. Votra Business er ikke revisor.",
  },
  {
    name: "Frode Laursen",
    src: "/partners/frode-laursen.png",
    role: "Transport- og logistikvirksomhed i vores netværk i branchen.",
  },
];

/* -------------------- Forsidens FAQ (synlig + schema) -------------------- */
export const HOME_FAQ = [
  {
    q: "Hvem laver bogføring og regnskab for vognmænd?",
    a: "Votra Business laver bogføring, moms, løn, fakturering, debitorstyring og årsrapporten for vognmænd og transportvirksomheder. Vi er en ekstern drifts- og økonomiafdeling: arbejdet udføres hos os, og du ser status i din egen portal. Skal regnskabet revideres eller forsynes med en revisorerklæring, løses den del af en revisor.",
  },
  {
    q: "Hvad er forskellen på en bogholder, en revisor og en financial controller?",
    a: "Bogholderen registrerer det, der er sket. Revisoren erklærer sig om årsregnskabet og er underlagt lovkrav. Financial controlleren bruger tallene fremadrettet: følger omkostninger, beregner resultat pr. bil og laver beslutningsgrundlag. Votra Business dækker bogholderi og controlling, ikke revision.",
  },
  {
    q: "Hvordan ser jeg, hvad hver lastbil tjener?",
    a: "Ved at holde indtægten pr. bil op mod bilens egne omkostninger: løn og tillæg til chaufføren, brændstof, leasing eller afskrivning, forsikring, service, dæk, vejafgifter og en andel af de faste omkostninger. Vi opstiller det pr. bil som del af controlling. Den automatiske visning i portalen er under udvikling.",
  },
  {
    q: "Hvad koster en lastbil om måneden?",
    a: "Det afhænger af bilen, aftalerne og kørslen, så et generelt tal siger ikke meget. Den faste del er typisk leasing eller finansiering, forsikring, vægtafgift og serviceaftale. Den variable del er brændstof, dæk, vejafgifter, reparationer og løn. Vi regner det igennem på dine egne aftaler i en driftsgennemgang.",
  },
  {
    q: "Kan jeg beholde min nuværende revisor?",
    a: "Ja. Vi overtager den løbende drift, bogføring, moms, løn, fakturering og controlling, og laver årsrapporten. Skal der en revisorerklæring på, arbejder vi sammen med din revisor og leverer et færdigt, afstemt grundlag. Du behøver ikke skifte noget for at komme i gang.",
  },
  {
    q: "Hvad skal jeg selv gøre, når Votra overtager driften?",
    a: "Sende det ind, der kommer ind ad døren, og svare på de spørgsmål vi stiller. Resten kører hos os: registrering, afstemning, fakturering, opfølgning på debitorer, løn, frister og rapportering. Du har én fast rådgiver at ringe til.",
  },
  {
    q: "Arbejder I kun med vognmænd?",
    a: "Vores dybeste specialisering er transport. Vi laver også bogføring, løn og administration for andre små og mellemstore virksomheder, de får samme driftsmodel uden fleet-delen.",
  },
  {
    q: "Hvor ligger Votra Business?",
    a: `Votra Business ApS (CVR ${BUSINESS.cvr}) har registreret adresse på ${BUSINESS.registered.street}, ${BUSINESS.registered.zip} ${BUSINESS.registered.city} og arbejder fra Votra-koncernens kontor på ${ADDRESS_LINE}. Vi arbejder for kunder i hele Danmark.`,
  },
];

/* -------------------- Schema -------------------- */
const BUSINESS_ID = `${SITE_URL}/business#organization`;
export { BUSINESS_ID };

export const businessOrganizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": BUSINESS_ID,
  name: "Votra Business",
  legalName: BUSINESS.legalName,
  description:
    "Votra Business ApS er en ekstern drifts- og økonomiafdeling for vognmænd og transportvirksomheder: bogføring, moms, løn, fakturering, debitorstyring, financial controlling, administrativ fleet management og dokument- og fristovervågning, samlet i én kundeportal med fast rådgiver.",
  url: `${SITE_URL}/business`,
  email: BUSINESS.email,
  telephone: BUSINESS.phone,
  vatID: BUSINESS.vatId,
  taxID: BUSINESS.cvr,
  areaServed: "DK",
  address: [
    {
      "@type": "PostalAddress",
      name: BUSINESS.registered.label,
      streetAddress: `${BUSINESS.registered.co}, ${BUSINESS.registered.street}`,
      postalCode: BUSINESS.registered.zip,
      addressLocality: BUSINESS.registered.city,
      addressCountry: "DK",
    },
    {
      "@type": "PostalAddress",
      name: BUSINESS.office.label,
      streetAddress: BUSINESS.office.street,
      postalCode: BUSINESS.office.zip,
      addressLocality: BUSINESS.office.city,
      addressCountry: "DK",
    },
  ],
  parentOrganization: { "@type": "Organization", name: "Votra Danmark ApS", url: SITE_URL },
  knowsAbout: [
    "Bogføring for vognmænd",
    "Lønadministration i transportbranchen",
    "Financial controlling",
    "Resultat pr. bil",
    "Administrativ fleet management",
    "Dokument- og fristovervågning for chauffører",
    "Virksomhedsopstart og tilladelser til godskørsel",
  ],
};

export const businessServiceJsonLd = ({ name, description, path }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": `${SITE_URL}${path}#service`,
  name,
  description,
  url: `${SITE_URL}${path}`,
  serviceType: name,
  provider: { "@id": BUSINESS_ID },
  areaServed: { "@type": "Country", name: "Danmark" },
  audience: { "@type": "BusinessAudience", audienceType: "Vognmænd og transportvirksomheder" },
});
